namespace Areas.CustomQuery {
    "user strict";

    export function createGridResult(): void {
        $("#CustomQueryResultGrid").dxDataGrid({
            dataSource: createDataSource(),
            remoteOperations: false,
            showBorders: true,
            allowColumnReordering: true,
            allowColumnResizing: true,
            columnAutoWidth: true,
            
            //showFilterRow: true,
            //useWidgetColumnResize: true,
            //showGroup: true,
            columnChooser: {
                mode: "select"
            },
            columnResizingMode: "widget",
            headerFilter: {
                visible: true
            },
            filterRow: {
                visible: true
            },
            groupPanel: {
                visible: true
            },
            columnFixing: { 
                enabled: true
            },
            paging: {
                pageSize: 10
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 50, 200, 1000],
                visible: true
            },
            onToolbarPreparing: Areas.addButtonsToToolbar(["columnChooser", "export"]),
            customizeColumns: customizeColumns, 
            onInitialized: (e) => Areas.CustomQuery.setGridIsInitialized()                                
        });                
    }

    function createDataSource(): DevExpress.data.DataSource {
        const storeConfiguration = {
            "loadParams": { 
                customQueryId: Areas.CustomQuery.getCustomQueryId(), 
                runQuery: Areas.CustomQuery.canExecuteQuery(), 
                parameters: getQueryParameters() 
            },
            "key": "",
            "loadUrl": "/CustomQuery/Main/GetResult",
            "insertUrl": "",
            "updateUrl": "",
            "deleteUrl": ""
        };

        const store = DevExpress.data.AspNet.createStore(storeConfiguration);
        return new DevExpress.data.DataSource({ store: store });        
    } 
    
    function getQueryParameters(): string {
        if (!Areas.CustomQuery.parameterFormIsInitialized()) {
            return null;
        }
        
        const form = $("#ParameterForm").dxForm("instance");
        const data = form.option("formData");
        const parameterList: any = form.option("parameterList");
        const parameterData = [];

        parameterList.forEach(parameterName => {
            const value = Areas.isEmpty(data[parameterName]) ? "" : data[parameterName];
            parameterData.push({name: parameterName, value: value});
        });

        return JSON.stringify(parameterData);
    }

    function customizeColumns(cols: any): void {
        const items = $("#CustomQueryResultGrid").dxDataGrid("instance").getDataSource().items();

        cols.forEach((col) => {
            const columnName = col.dataField as string;
            const columnValue = items[0][columnName];

            if(isAValidDate(columnValue, columnName)){
                col.dataType = "date";
                col.format = "shortDateShortTime";
            } 
        })
    }
    
    function isAValidDate(columnValue: any, columnName: string): boolean {
        let isValid = false;

        if(Areas.isNotEmpty(columnValue)) {
            isValid = moment(columnValue, moment.ISO_8601, true).isValid();
        } else {
            const columnNameContainsDate = columnName.toLowerCase().indexOf("date") > -1;

            if (columnNameContainsDate) {
                isValid = true;
            }
        }        

        return isValid;
    }
}
